import hikvisionVideo from './hikvision-video'

let install = function (Vue) {
  Vue.component(hikvisionVideo.name, hikvisionVideo)
}

export default { install }
